"use client"

import { CYCLE_FROM_QUERY_KEY, ITEM_FROM_QUERY_KEY } from "common/helper/const"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import React, { useEffect, useMemo, useState } from "react"
import { Tabs, type TabsProps } from "antd"

import type { TabItem } from "./index"

type Props = {
	activeKey: string
	items: TabItem[]
	paramKey?: string
}

const ReportClientTab: React.FC<Props> = ({ activeKey: propActiveKey, items, paramKey = "tab" }) => {
	const router = useRouter()
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const urlKey = useMemo(() => searchParams.get(paramKey), [searchParams, paramKey])
	const mergedKey = urlKey || propActiveKey
	const [activeKey, setActiveKey] = useState<string>(mergedKey)

	useEffect(() => {
		setActiveKey(mergedKey)
	}, [mergedKey])

	// Tab切换时，更新URL参数，并删除其他参数
	const onChange = (key: string) => {
		const params = new URLSearchParams(searchParams.toString())
		params.set(paramKey, key)
		params.delete(CYCLE_FROM_QUERY_KEY)
		params.delete(ITEM_FROM_QUERY_KEY)
		router.push(`${pathname}?${params.toString()}`, { scroll: false })
	}

	const tabs: TabsProps["items"] = items.map((i) => ({
		key: i.key,
		label: i.label,
		children: i.children ?? null,
	}))

	return <Tabs activeKey={activeKey} animated={false} onChange={onChange} items={tabs} />
}

export default ReportClientTab
